module.exports = __webpack_public_path__ + "static/media/16.5cdf2043.png";